// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import { Text } from '~/design-system';
import ChooseCollection, {
  useChooseCollection,
} from '../../../../components/ChooseProductList/ChooseProductList';
import Error from '../../../../components/Error';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import { ProgressIndicator, useLink } from './_config';

export default function ProductList({ match }) {
  const link = useLink('productList');
  const history = useHistory();
  const { workspaceId, importId } = match.params;
  const props = useChooseCollection({ workspaceId, importId });

  if (props.errorCode === 'request_id_invalid') {
    return (
      <Error>
        <Text>
          <Trans>Sorry, you have invalid request ID's on your import.</Trans>
        </Text>
        <Text>
          <Trans>Import can't continue.</Trans>
        </Text>
      </Error>
    );
  }

  return (
    <Layout>
      <ProgressIndicator step="collection" />
      <PageHeader>
        <PageTitle>
          <Trans>Choose product list</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Choose a list to import the products into.</Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <ChooseCollection {...props} />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton
          onClick={async () => {
            const result = await props.updateImportCollectionId();
            if (!result?.error) history.push(link.next());
          }}
          disabled={!props.isValid}
        />
      </Footer>
    </Layout>
  );
}
